module.exports = __webpack_public_path__ + "static/media/comingsoon.c023658b.svg";